(function () {
  'use strict';

  function hasConsent() {
    return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() || false;
  }

  function findLatestDataLayerEvent(eventName) {
    var dl = window.dataLayer || [];
    for (var i = dl.length - 1; i >= 0; i--) {
      if (dl[i] && dl[i].event === eventName) {
        return dl[i];
      }
    }
    return null;
  }

  function onNextDataLayerEvent(eventName, callback) {
    var orig = window.dataLayer.push;
    window.dataLayer.push = function () {
      var result = orig.apply(this, arguments);
      for (var i = 0; i < arguments.length; i++) {
        var item = arguments[i];
        if (item && item.event === eventName) {
          window.dataLayer.push = orig; // restore immediately — one-shot
          callback(item);
        }
      }
      return result;
    };
  }

  function initShopifyDVars() {
    var shopify = window.Shopify || {};
    window._uxa = window._uxa || [];
    window._uxa.push(['trackDynamicVariable', { key: 'themeId',  value: String(window.shopifyThemeId || '') }]);
    window._uxa.push(['trackDynamicVariable', { key: 'locale',   value: shopify.locale || '' }]);
    window._uxa.push(['trackDynamicVariable', { key: 'currency', value: (shopify.currency && shopify.currency.active) || '' }]);
    window._uxa.push(['trackDynamicVariable', { key: 'country',  value: window.shopifyCountry || '' }]);
  }

  function fireDVars(userType) {
    window._uxa = window._uxa || [];
    window._uxa.push(['trackDynamicVariable', {
      key: 'visitorType',
      value: (userType === 'member') ? 'member' : 'guest'
    }]);
    window._uxa.push(['trackDynamicVariable', {
      key: 'userType',
      value: userType || 'visitor'
    }]);
  }

  function initDVars() {
    var entry = findLatestDataLayerEvent('sh_info');
    var userType = (entry && entry.user && entry.user.type) ? entry.user.type : 'visitor';
    fireDVars(userType);
  }

  var pdpCVarData = {};

  function pushCVars() {
    window._uxa = window._uxa || [];
    if (!pdpCVarData.productId) return;

    window._uxa.push(['setCustomVariable', 1, 'categoryName',  pdpCVarData.categoryName || '', 3]);
    window._uxa.push(['setCustomVariable', 2, 'productId',     pdpCVarData.productId    || '', 3]);
    window._uxa.push(['setCustomVariable', 3, 'productSku',    pdpCVarData.productSku   || '', 3]);
    window._uxa.push(['setCustomVariable', 4, 'stockStatus',   pdpCVarData.stockStatus  || '', 3]);
    window._uxa.push(['setCustomVariable', 5, 'variantId',     pdpCVarData.variantId    || '', 3]);
    window._uxa.push(['setCustomVariable', 6, 'selectedSize',  pdpCVarData.selectedSize || '', 3]);
  }

  function applyProductDetailEntry(entry) {
    if (!entry) return;
    pdpCVarData.categoryName = entry.category_name || '';
    pdpCVarData.productId    = String(entry.product_id || '');
    pdpCVarData.productSku   = entry.product_sku || '';
    pdpCVarData.variantId    = String(entry.variant_id || '');
    // Shopify uses "Default Title" when a product has no real variants —
    // send empty string so CSQ doesn't record a meaningless placeholder
    var rawTitle = entry.variant_title || '';
    pdpCVarData.selectedSize = (rawTitle === 'Default Title') ? '' : rawTitle;
  }

  function pushCVarsWhenReady() {
    var stockEntry = findLatestDataLayerEvent('stock_status_impression');
    if (stockEntry) {
      pdpCVarData.stockStatus = stockEntry.stock_status_name || '';
      pushCVars();
    } else {
      // stock_status_impression is consent-gated and races with this script —
      // wait for it so we never push an empty stockStatus
      onNextDataLayerEvent('stock_status_impression', function (item) {
        pdpCVarData.stockStatus = item.stock_status_name || '';
        pushCVars();
      });
    }
  }

  function initCVars() {
    var pdpEntry = findLatestDataLayerEvent('ee_productDetail');
    applyProductDetailEntry(pdpEntry);
    pushCVarsWhenReady();

    // Analyzify doesn't push ee_productDetail on colour swap, so fetch product JSON directly
    document.addEventListener('colorVariantChanged', function (event) {
      var url = event.detail && event.detail.url;
      if (!url) return;

      var preservedCategory = pdpCVarData.categoryName || '';
      pdpCVarData = {};
      pdpCVarData.categoryName = preservedCategory;

      fetch(url + '.json')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var product = data.product;
          if (!product) return;

          var firstVariant = product.variants && product.variants[0];

          pdpCVarData.productId  = String(product.id || '');
          pdpCVarData.productSku = (firstVariant && firstVariant.sku) || '';
          pdpCVarData.variantId  = String((firstVariant && firstVariant.id) || '');

          var rawTitle = (firstVariant && firstVariant.title) || '';
          pdpCVarData.selectedSize = (rawTitle === 'Default Title') ? '' : rawTitle;

          var badgeEl = document.querySelector('.stockbadge_placeholder .product__badge[data-stock-state]');
          if (badgeEl) {
            var raw = badgeEl.getAttribute('data-stock-state') || '';
            pdpCVarData.stockStatus = raw
              .replace(/_/g, ' ')
              .split(' ')
              .map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); })
              .join(' ');
          } else {
            pdpCVarData.stockStatus = '';
          }

          pushCVars();
        })
        .catch(function (e) {
          console.error('CSQ: failed to fetch product data after colour swap', e);
        });
    });
  }

  function fireMiniBagOpen() {
    window._uxa = window._uxa || [];
    window._uxa.push([
      'setQuery',
      window.location.search + (window.location.search ? '&' : '?') + 'cs-popin-mini-bag',
      { lifespan: 'onNextPageviewOnly' }
    ]);
    window._uxa.push([
      'trackPageview',
      window.location.pathname + window.location.hash.replace('#', '?__'),
      { lifespan: 'onNextPageviewOnly' }
    ]);
  }

  function fireMiniBagClose() {
    window._uxa = window._uxa || [];
    window._uxa.push([
      'trackPageview',
      window.location.pathname + window.location.hash.replace('#', '?__')
    ]);
  }

  function initMiniBagPageview() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    var originalOpen = cartDrawer.open.bind(cartDrawer);
    cartDrawer.open = function (triggeredBy) {
      fireMiniBagOpen();
      return originalOpen(triggeredBy);
    };

    var originalClose = cartDrawer.close.bind(cartDrawer);
    cartDrawer.close = function () {
      fireMiniBagClose();
      return originalClose();
    };
  }

  function fireAddToCart(sku) {
    window._uxa = window._uxa || [];
    window._uxa.push(['trackPageEvent', 'addToCart']);
    window._uxa.push([
      'ec:cart:add',
      {
        sku: sku || '',
        merchant: window.location.hostname
      }
    ]);
  }

  function initAddToCart() {
    document.addEventListener('csq:addToCart', function (event) {
      var sku = event.detail && event.detail.sku ? event.detail.sku : '';
      fireAddToCart(sku);
    });
  }

  function initIdentify() {
    var entry = findLatestDataLayerEvent('sh_info');
    if (!entry || !entry.user || entry.user.type !== 'member') return;
    var customerId = entry.user.id;
    if (!customerId) return;
    window._uxa = window._uxa || [];
    window._uxa.push(['identify', String(customerId)]);
  }

  function boot() {
    if (!hasConsent()) return;
    initShopifyDVars();
    initDVars();
    initIdentify();
    initCVars();
    initMiniBagPageview();
    initAddToCart();
  }

  if (hasConsent()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  }

  document.addEventListener('visitorConsentCollected', function () {
    if (hasConsent()) boot();
  });

})();
